import React from "react";
import { Box, Typography } from "@mui/material";
import { afbeeldingAdres } from '../../../instellingen';

const IMG_URL = afbeeldingAdres;

export const AlreadySubmittedCard = ({ basicLanguages, companyLogo }) => (
  <Box
    sx={{
      minHeight: "100vh",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      textAlign: "center",
      px: 3,
      background: "#fafafa",
      gap: 2,
    }}
  >
    <Box
      sx={{
        width: 80,
        height: 80,
        borderRadius: "50%",
        background: "linear-gradient(135deg, #d1fae5, #a7f3d0)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        mb: 1,
      }}
    >
      <Typography sx={{ fontSize: 36 }}>✅</Typography>
    </Box>

    <Typography
      sx={{
        fontSize: { xs: "22px", sm: "28px" },
        fontWeight: 700,
        color: "#1a1a1a",
      }}
    >
      {basicLanguages?.AlreadySubmitted || "Je hebt deze enquete al ingevuld"}
    </Typography>

    <Typography
      sx={{
        fontSize: { xs: "13px", sm: "15px" },
        color: "#6b7280",
        maxWidth: 420,
        lineHeight: 1.8,
      }}
    >
      {basicLanguages?.AlreadySubmittedSubtitle ||
        "It looks like you've already shared your feedback for this reservation. We truly appreciate your response!"}
    </Typography>

    {companyLogo && (
      <Box
        sx={{
          mt: 4,
          width: { xs: 100, sm: 140 },
          height: { xs: 50, sm: 60 },
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <img
          src={`${IMG_URL}/${companyLogo}`}
          alt="Company Logo"
          style={{
            maxWidth: "100%",
            maxHeight: "100%",
            objectFit: "contain",
          }}
        />
      </Box>
    )}
  </Box>
);
